import React from "react";
import Footer from "../components/Footer";
import { useNavigate } from "react-router-dom";

import "../styles/App.css";

function Imprint() {
  const navigate = useNavigate();

  return (
    <div
      className="Imprint"
      style={{
        margin: "auto",
        marginTop: 64,
        maxWidth: 800,
        marginTop: 32,
        padding: 32,
      }}
    >
      <img
        src="logo.svg"
        alt="Logo"
        style={{
          width: 400,
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
          cursor: "pointer",
        }}
        onClick={() => navigate("/")}
      />

      <h1 style={{ textAlign: "center", marginTop: 64, fontSize: 40 }}>
        Imprint
      </h1>
      <br />
      <h2>Angaben gemäß § 5 TMG</h2>
      <p>
        <strong>Code for Conservation</strong>
        <br />
        Frank Fundel
        <br />
        Danzigerstraße 4<br />
        89584 Ehingen
        <br />
        Deutschland
      </p>

      <br />
      <h2>Kontakt</h2>
      <p>
        E-Mail:{" "}
        <a href="mailto:info@code4conservation.de">info@code4conservation.de</a>
      </p>

      <br />
      <h2>Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
      <p>
        Frank Fundel
        <br />
        Danzigerstraße 4<br />
        89584 Ehingen
      </p>

      <br />
      <h2>Haftung für Inhalte</h2>
      <p>
        Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf
        diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8
        bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
        übermittelte oder gespeicherte fremde Informationen zu überwachen oder
        nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
        hinweisen.
      </p>
      <p>
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
        Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
        Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
        Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
        entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
        entfernen.
      </p>

      <br />
      <h2>Online-Streitbeilegung gemäß Art. 14 Abs. 1 ODR-VO</h2>
      <p>
        Die Europäische Kommission stellt eine Plattform zur
        Online-Streitbeilegung (OS) bereit, die Sie unter{" "}
        <a href="https://ec.europa.eu/consumers/odr/" target="_blank">
          https://ec.europa.eu/consumers/odr/
        </a>{" "}
        finden. Wir sind weder verpflichtet noch bereit, an einem
        Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        teilzunehmen.
      </p>

      <br />
      <h2>Datenspeicherung und -verarbeitung</h2>
      <p>
        Wir speichern und verarbeiten Daten, die von Nutzern ausdrücklich
        hochgeladen oder bereitgestellt werden. Die Verarbeitung erfolgt
        ausschließlich auf Basis der vorherigen Einwilligung der Nutzer. Weitere
        Informationen zur Speicherung und Verarbeitung personenbezogener Daten
        sind in unserer Datenschutzerklärung zu finden.
      </p>

      <br />
      <h2>Urheberrecht</h2>
      <p>
        Die durch Code for Conservation erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
        sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
      </p>
      <p>
        Soweit die Inhalte auf dieser Seite nicht von uns erstellt wurden,
        werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
        Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
        wir derartige Inhalte umgehend entfernen.
      </p>

      <Footer />
    </div>
  );
}

export default Imprint;
